import { render } from "./splash_page.vue?vue&type=template&id=4e546572&scoped=true"
import script from "./splash_page.vue?vue&type=script&lang=js"
export * from "./splash_page.vue?vue&type=script&lang=js"

import "./splash_page.vue?vue&type=style&index=0&id=4e546572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e546572"]])

export default __exports__